import { Pipe, PipeTransform } from '@angular/core';
import { CandidateSalary } from '../../models/candidate-salary.model';
import { SalaryService } from '../../services/salary.service';

@Pipe({ name: 'salary' })
export class SalaryPipe implements PipeTransform {
  constructor(private salaryService: SalaryService) {}

  transform(value: CandidateSalary | null | undefined): string | null {
    return this.salaryService.format(value);
  }
}
